import type { Gsr, GsrStatus } from './api.ts';
import { t } from '../../lib/strings.ts';

const RAW_LABELS: Record<GsrStatus, string> = {
  DRAFT: t.gsr.statusDraft,
  PENDING_SIGNATURE: t.gsr.statusPendingSignature,
  APPROVED: t.gsr.statusApproved,
  RFQ_GENERATED: t.gsr.statusRfqGenerated,
};

type GsrLike = Pick<Gsr, 'status' | 'request'>;

// Effective status. Once the linked RFQ is awarded, the GSR advances through the
// contract → payment lifecycle (contracted → being paid → paid), regardless of
// its own enum value.
export function gsrStatusLabel(g: GsrLike): string {
  const a = g.request?.award;
  if (a?.paid) return t.gsr.statusPaid;
  if (a?.sentToFinanceAt) return t.gsr.statusPaying;
  if (a) return t.gsr.statusContracted;
  return RAW_LABELS[g.status];
}

export function gsrStatusPill(g: GsrLike): string {
  const a = g.request?.award;
  if (a?.paid) return 'pill pill-success';
  if (a?.sentToFinanceAt) return 'pill pill-pending';
  if (a) return 'pill pill-success';
  switch (g.status) {
    case 'DRAFT': return 'pill pill-neutral';
    case 'PENDING_SIGNATURE': return 'pill pill-pending';
    case 'APPROVED': return 'pill pill-success';
    case 'RFQ_GENERATED': return 'pill pill-success';
  }
}
